import { Head, Link } from '@inertiajs/react'

import { CategoryType } from './types'
import {ArrowLeft, Edit, Tag} from "lucide-react";

interface ShowProps {
  category: CategoryType
}

export default function Show({ category }: ShowProps) {


  return (
    <>
      <Head title={`Category #${category.id}`} />
      <div className="flex flex-col gap-6 p-8">
        {/* Header */}
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-4">
            <Link href="/system/categories">
              <button className="rounded-lg border border-border p-2 text-foreground hover:bg-secondary transition-colors">
                <ArrowLeft className="h-5 w-5" />
              </button>
            </Link>
            <div>
              <div className="flex items-center gap-3">
                <div className="rounded-lg bg-primary/10 p-3">
                  <Tag className="h-6 w-6 text-primary" />
                </div>
                <div>
                  <h1 className="text-3xl font-bold text-foreground">{category.name}</h1>
                  <p className="text-sm text-muted-foreground">{category.code}</p>
                </div>
              </div>
            </div>
          </div>
          <Link href={`/system/categories/${category.id}/edit`}>
            <button className="flex items-center gap-2 rounded-lg bg-primary px-4 py-2 text-sm font-medium text-primary-foreground hover:bg-primary/90 transition-colors">
              <Edit className="h-4 w-4" />
              Edit Category
            </button>
          </Link>
        </div>
      </div>
    </>
  )
}
